(function() { module.exports = window["Backbone"]; }());


//////////////////
// WEBPACK FOOTER
// external "Backbone"
// module id = 2
// module chunks = 88